import styled from 'styled-components';

const OrangeButton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  flex: 1 0 auto;
  min-width: 129px;
  height: 44px;
  background: #e06e4d;
  border-radius: 4px;

  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  font-feature-settings: 'ss06' on;
  color: #fafafa;
`;
export default OrangeButton;
